(function () {
  function renameLoadMore() {
    var root = document.getElementById('looxReviews');
    if (!root) return;
    root.querySelectorAll('button, a, span').forEach(function (el) {
      var text = (el.textContent || '').trim();
      if (/^(load more|show more|see more)( reviews)?$/i.test(text)) {
        el.textContent = 'Show more reviews';
      }
    });
  }

  function neutralizeReviewLinks() {
    var root = document.getElementById('looxReviews');
    if (!root) return;
    root.querySelectorAll('[class*="review"] a[href], [class*="comment"] a[href], [class*="content"] a[href]').forEach(function (link) {
      var href = link.getAttribute('href') || '';
      if (!href || href.charAt(0) === '#' || href.indexOf('loox.io') !== -1 || href.indexOf('defdelete.com') !== -1) {
        return;
      }
      if (/^https?:/i.test(href) || href.indexOf('//') === 0 || href.indexOf('www.') === 0) {
        var text = document.createTextNode(link.textContent);
        link.parentNode.replaceChild(text, link);
      }
    });
  }

  function enhance() {
    renameLoadMore();
    neutralizeReviewLinks();
  }

  document.addEventListener('DOMContentLoaded', enhance);
  document.addEventListener('shopify:section:load', enhance);

  var reviews = document.getElementById('looxReviews');
  if (reviews && window.MutationObserver) {
    new MutationObserver(enhance).observe(reviews, { childList: true, subtree: true });
  }
})();
